module.exports = __webpack_public_path__ + "static/anne-wojcicki-b8efe18fa04863bf711089c1c85449d8.jpg";